import { useEffect, useState } from 'react'
import {
  getDataDetailTable, getDataDetailTableglobal, getTableconnectorsyear, getTableconnectorsyearglobal,
  getTableconnectorsyears, getTableconnectorsyearsglobal
} from '../requests/request';
import { useAppSelector } from "../../../../../../redux/hooks"
import { useAuth } from '../../../../auth';

export default function DataDetail(props: any) {

  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type) || "CloudGlobal";
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)
  const [firstLoad, setFirstLoad] = useState(true);
  const { currentUser } = useAuth()

  const [dataConnector, setdataConnector] = useState({
    date: {
      start: '',
      end: ''
    },
    data: [{
      TXGb: 0,
      RXGb: 0,
      ConnectorName: '',
      InstanceName: ''
    }]
  })

  useEffect(() => {
    console.log("dataDetail");
    const fetchData = async () => {
      try {
        if (Id !== 0 && Type !== 'CloudGlobal' && props.Year !== '' && props.mes !== '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          if (tenant === 0) {
            const connector = await getDataDetailTable(Id, props.Year, props.mes, Type, nameregion);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
          else {
            const connector = await getDataDetailTableglobal(Id, props.Year, props.mes, tenant, Type, nameregion);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
        }
        else if (Id !== 0 && Type === 'CloudGlobal' && props.Year !== '' && props.mes !== '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          if (tenant === 0) {
            const connector = await getDataDetailTable(Id, props.Year, props.mes);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
          else {
            const connector = await getDataDetailTableglobal(Id, props.Year, props.mes, tenant);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
        }

        else if (Id !== 0 && Type !== 'CloudGlobal' && props.Year !== '' && props.mes === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          if (tenant === 0) {
            const connector = await getTableconnectorsyear(Id, props.Year, Type, nameregion);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
          else {
            const connector = await getTableconnectorsyearglobal(Id, props.Year, tenant, Type, nameregion);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
        }

        else if (Id !== 0 && Type === 'CloudGlobal' && props.Year !== '' && props.mes === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          if (tenant === 0) {
            const connector = await getTableconnectorsyear(Id, props.Year);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
          else {
            const connector = await getTableconnectorsyearglobal(Id, props.Year, tenant);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
        }


        else if (Id !== 0 && Type !== 'CloudGlobal' && props.Year === '' && props.mes === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          if (tenant === 0) {
            const connector = await getTableconnectorsyears(Id, Type, nameregion);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
          else {
            const connector = await getTableconnectorsyearsglobal(Id, tenant, Type, nameregion);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
        }
        else if (Id !== 0 && Type === 'CloudGlobal' && props.Year === '' && props.mes === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          if (tenant === 0) {
            const connector = await getTableconnectorsyears(Id);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
          else {
            const connector = await getTableconnectorsyearsglobal(Id, tenant);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
        }

      } catch (error) {
        console.error('Error al obtener los datos:', error);
        setdataConnector({ date: { start: '', end: '' }, data: [] });
      }
    };

    fetchData();
    setFirstLoad(false);
  }, [Id, props.Year, props.mes, FlagReg, firstLoad, nameregion, currentUser, tenant, Type])

  /*****************************global temporal ************************************ */
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id && Type === 'CloudGlobal' && props.Year !== '' && props.mes !== '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          if (tenant === 0) {
            const connector = await getDataDetailTable(Id, props.Year, props.mes);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
          else if (tenant !== 0) {
            const connector = await getDataDetailTableglobal(Id, props.Year, props.mes, tenant);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
        }
        else if (Id && Type === 'CloudGlobal' && props.Year !== '' && props.mes === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          if (tenant === 0) {
            const connector = await getTableconnectorsyear(Id, props.Year);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
          else if (tenant !== 0) {
            const connector = await getTableconnectorsyearglobal(Id, props.Year, tenant);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
        }

        else if (Id && Type === 'CloudGlobal' && props.Year === '' && props.mes === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          if (tenant === 0) {
            const connector = await getTableconnectorsyears(Id);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
          else if (tenant !== 0) {
            const connector = await getTableconnectorsyearsglobal(Id, tenant);
            setdataConnector(connector?.data ?? { date: { start: '', end: '' }, data: [] });
          }
        }

      } catch (error) {
        console.error('Error al obtener los datos:', error);
        setdataConnector({ date: { start: '', end: '' }, data: [] });
      }
    };

    fetchData();
    setFirstLoad(false);
  }, [tenant, Id, props.Year, props.mes, firstLoad, currentUser, Type])

  if (Id !== 0) {

    return (

      <div className="card">
        <div >
          {/* begin::Header */}
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='f-titulo text-marino fs-md'>Connectors</span>
            </h3>
            <div className="card-toolbar text-center text-gray-400">
              <div  >
                <strong className='text-gray-400'>Data Period </strong>
                <br />
                <strong className='text-gray-400'>Start Date:</strong> {dataConnector?.date?.start || 'N/A'}
                <br />
                <strong className='text-gray-400'>End Date:</strong> {dataConnector?.date?.end || 'N/A'}
              </div>
            </div>
          </div>

          {/* end::Header */}

          {/* begin::Body */}
          <div className='card-body py-3'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='w-full f-parrafo  caption-bottom  custom-table'>
                {/* begin::Table head */}
                <thead>
                  <tr className='table-header-light bg-marino'>
                    <th className='table-cell'></th>
                    <th className='table-cell'>Connector Type</th>
                    <th className='table-cell'>CTX Connector</th>
                    <th className='table-cell'>CTX Instance</th>
                    <th className='table-cell'>Inbound</th>
                    <th className='table-cell'>Outbound</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {
                    (dataConnector?.data?.filter(item => item.ConnectorName.includes('VPN')) || []).map((d, i) =>
                      <tr key={i + "VPN"} className='table-row'>
                        <td id='id' className='table-cell'>
                          <div className='symbol symbol-45px me-2'>
                            {/*<KTIcon iconName='bi bi-ethernet' className='text-marino fs-1' />*/}
                            <img src="/media/iconos_v2/VPNP.svg" alt="" />
                          </div>
                        </td>
                        <td className='table-cell'>
                          {d.ConnectorName?.includes('VPN') ? 'VPN Connector' : 'N/A'}
                        </td>
                        <td className='table-cell'>{d.ConnectorName || 'N/A'}</td>
                        <td className='table-cell'>{d.InstanceName || 'N/A'}</td>
                        <td className='table-cell'>{d.RXGb !== undefined ? `${d.RXGb} GB` : 'N/A'}</td>
                        <td className='table-cell'>{d.TXGb !== undefined ? `${d.TXGb} GB` : 'N/A'}</td>
                      </tr>
                    )
                  }
                  {
                    (dataConnector?.data?.filter(item => item.ConnectorName.includes('CPR')) || []).map((d, i) =>

                      <tr key={i + "CPR"} className='table-row'>
                        <td id='id' className='table-cell'>
                          <div className='symbol symbol-45px me-2'>
                            {/*<KTIcon iconName='bi bi-ethernet' className='text-marino fs-1' />*/}
                            <img src="/media/iconos_v2/CPR.svg" alt="" />

                          </div>
                        </td>
                        <td className='table-cell'>
                          {d.ConnectorName?.includes('CPR') ? 'Cloud Connector' : 'N/A'}
                        </td>
                        <td className='table-cell'>{d.ConnectorName || 'N/A'}</td>
                        <td className='table-cell'>{d.InstanceName || 'N/A'}</td>
                        <td className='table-cell'>{d.RXGb !== undefined ? `${d.RXGb} GB` : 'N/A'}</td>
                        <td className='table-cell'>{d.TXGb !== undefined ? `${d.TXGb} GB` : 'N/A'}</td>
                      </tr>
                    )

                  }
                  {
                    (dataConnector?.data?.filter(item => item.ConnectorName.includes('EDG')) || []).map((d, i) =>

                      <tr key={i + "EDG"} className='table-row'>
                        <td id='id' className='table-cell'>
                          <div className='symbol symbol-45px me-2'>

                            <img src="/media/iconos_v2/EDG.svg" alt="" style={{ width: '100%' }} />
                          </div>
                        </td>

                        <td className='table-cell'>
                          {d.ConnectorName?.includes('EDG') ? 'Edge Connector' : 'N/A'}
                        </td>
                        <td className='table-cell'>{d.ConnectorName || 'N/A'}</td>
                        <td className='table-cell'>{d.InstanceName || 'N/A'}</td>
                        <td className='table-cell'>{d.RXGb !== undefined ? `${d.RXGb} GB` : 'N/A'}</td>
                        <td className='table-cell'>{d.TXGb !== undefined ? `${d.TXGb} GB` : 'N/A'}</td>
                      </tr>
                    )

                  }
                </tbody>


              </table>
              {/* end::Table */}
            </div>
            {/* end::Table container */}
          </div>
          {/* begin::Body */}
        </div>
      </div>
    )
  } else {
    return (
      <>
        {/*<div className="card-body d-flex flex-column flex-row-fluid">
        <div className="card-body d-flex flex-column-auto flex-center">
          <h3>Select Purchase Order and Cloud Account</h3>
        </div>
    </div>*/}
        <div className="card">
          <div >
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='f-titulo text-marino fs-md'>Connectors</span>
              </h3>
              <div className="card-toolbar text-center text-gray-400">
                <div  >
                  <strong className='text-gray-400'>Data Period </strong>
                  <br />
                  <strong className='text-gray-400'>Start Date:</strong> {dataConnector?.date?.start || 'N/A'}
                  <br />
                  <strong className='text-gray-400'>End Date:</strong> {dataConnector?.date?.end || 'N/A'}
                </div>
              </div>
            </div>

            {/* end::Header */}

            {/* begin::Body */}
            <div className='card-body py-3'>
              {/* begin::Table container */}
              <div className='table-responsive'>
                {/* begin::Table */}
                <table className='w-full f-parrafo  caption-bottom  custom-table'>
                  {/* begin::Table head */}
                  <thead>
                    <tr className='table-header-light bg-marino'>
                      <th className='table-cell'></th>
                      <th className='table-cell'>Connector Type</th>
                      <th className='table-cell'>CTX Connector</th>
                      <th className='table-cell'>CTX Instance</th>
                      <th className='table-cell'>Inbound</th>
                      <th className='table-cell'>Outbound</th>
                    </tr>
                  </thead>
                  {/* end::Table head */}
                  {/* begin::Table body */}
                  <tbody>
                    {
                      (dataConnector?.data?.filter(item => item.ConnectorName.includes('VPN')) || []).map((d, i) =>

                        <tr key={i + "VPN"} className='table-row'>
                          <td id='id' className='table-cell'>
                            <div className='symbol symbol-45px me-2'>
                              {/*<KTIcon iconName='bi bi-ethernet' className='text-marino fs-1' />*/}
                              <img src="/media/iconos_v2/VPNP.svg" alt="" />
                            </div>
                          </td>
                          <td className='table-cell'>
                            {d.ConnectorName?.includes('VPN') ? 'VPN Connector' : 'N/A'}
                          </td>
                          <td className='table-cell'>{d.ConnectorName || 'N/A'}</td>
                          <td className='table-cell'>{d.InstanceName || 'N/A'}</td>
                          <td className='table-cell'>{d.RXGb !== undefined ? `${d.RXGb} GB` : 'N/A'}</td>
                          <td className='table-cell'>{d.TXGb !== undefined ? `${d.TXGb} GB` : 'N/A'}</td>
                        </tr>
                      )
                    }
                    {
                      (dataConnector?.data?.filter(item => item.ConnectorName.includes('CPR')) || []).map((d, i) =>

                        <tr key={i + "CPR"} className='table-row'>
                          <td id='id' className='table-cell'>
                            <div className='symbol symbol-45px me-2'>
                              {/*<KTIcon iconName='bi bi-ethernet' className='text-marino fs-1' />*/}
                              <img src="/media/iconos_v2/CPR.svg" alt="" />

                            </div>
                          </td>
                          <td className='table-cell'>
                            {d.ConnectorName?.includes('CPR') ? 'Cloud Connector' : 'N/A'}
                          </td>
                          <td className='table-cell'>{d.ConnectorName || 'N/A'}</td>
                          <td className='table-cell'>{d.InstanceName || 'N/A'}</td>
                          <td className='table-cell'>{d.RXGb !== undefined ? `${d.RXGb} GB` : 'N/A'}</td>
                          <td className='table-cell'>{d.TXGb !== undefined ? `${d.TXGb} GB` : 'N/A'}</td>
                        </tr>
                      )

                    }
                    {
                      (dataConnector?.data?.filter(item => item.ConnectorName.includes('EDG')) || []).map((d, i) =>

                        <tr key={i + "EDG"} className='table-row'>
                          <td id='id' className='table-cell'>
                            <div className='symbol symbol-45px me-2'>

                              <img src="/media/iconos_v2/EDG.svg" alt="" style={{ width: '100%' }} />
                            </div>
                          </td>

                          <td className='table-cell'>
                            {d.ConnectorName?.includes('EDG') ? 'Edge Connector' : 'N/A'}
                          </td>
                          <td className='table-cell'>{d.ConnectorName || 'N/A'}</td>
                          <td className='table-cell'>{d.InstanceName || 'N/A'}</td>
                          <td className='table-cell'>{d.RXGb !== undefined ? `${d.RXGb} GB` : 'N/A'}</td>
                          <td className='table-cell'>{d.TXGb !== undefined ? `${d.TXGb} GB` : 'N/A'}</td>
                        </tr>
                      )

                    }
                  </tbody>


                </table>
                {/* end::Table */}
              </div>
              {/* end::Table container */}
            </div>
            {/* begin::Body */}
          </div>
        </div>
      </>
    )
  }
}
